import { type ReactElement } from 'react';
import { bikeRoadsSth } from '../LayerFactories';
import { LeafletMap } from '../Map';

import type { Map } from 'leaflet';
import type { PageMapProps } from './types';

export const BikeRoadsSthPageMap = (props: PageMapProps): ReactElement => {
    const mapProps = props.mapSettings;

    const setupMap = (map: Map): void => {
        bikeRoadsSth(mapProps.mapServerUrl, mapProps.mapTilesVersion).addTo(map);
    };

    return <LeafletMap {...mapProps} showMyPosition={true} showMobileFullscreenOverlay={true} onMapInitiated={setupMap} />;
};
